import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import { getHistoryFormattedTimestamp } from 'conversations-message-history/util/getHistoryFormattedTimestamp';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPrimaryMessageHeaderContent = styled(PrimaryMessageHeaderContent).withConfig({
  displayName: "InitialMessageHeader__StyledPrimaryMessageHeaderContent",
  componentId: "euhlou-0"
})(["padding:8px 8px 0 8px;display:flex;"]);
const StyledSpan = styled.span.withConfig({
  displayName: "InitialMessageHeader__StyledSpan",
  componentId: "euhlou-1"
})(["margin-left:auto;"]);
const StyledSmall = styled.small.withConfig({
  displayName: "InitialMessageHeader__StyledSmall",
  componentId: "euhlou-2"
})(["display:contents;"]);
const InitialMessageHeader = ({
  timestamp
}) => {
  return /*#__PURE__*/_jsx(StyledPrimaryMessageHeaderContent, {
    children: /*#__PURE__*/_jsxs(StyledSmall, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.initial-message.headerTooltip"
        }),
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.initial-message.header"
          })
        })
      }), /*#__PURE__*/_jsx(StyledSpan, {
        children: getHistoryFormattedTimestamp(timestamp)
      })]
    })
  });
};
InitialMessageHeader.displayName = 'InitialMessageHeader';
InitialMessageHeader.propTypes = {
  timestamp: PropTypes.number.isRequired
};
export default InitialMessageHeader;